<template lang="pug">
<!-- eslint-disable -->
mixin wrapper
  .wrapper.w-full(
    :class="[{ 'items-center mx-auto': screen.center }, screen['no-wrap'] && 'wrapper-span-edge']"
  )&attributes(attributes)
    //- allows nesting within this mixin
    block

    //- allows nesting in the vue tree, to append content after the block
    slot

mixin title
  - var vClass = `twMerge('pb-2 inline-block',(screen.subheading || screen.h === 'h4') ? 'subheading' : 'heading', ${JSON.stringify(attributes.class)}, screen.styles?.title, screen.styles?.heading, screen.styles?.subheading)`;

  uc-editable(
    :class=vClass
    :text="screen.heading || screen.subheading || screen.title"
    :type="screen.subheading ? 'h4' : screen.h ? screen.h : 'h3'"
    :values="screen['placeholder-values']"
    v-if="screen.heading || screen.subheading || screen.title"
  )&attributes(attributes)

mixin content
  uc-content(:editPath="editPath" :screen="screen")

mixin next({ locked, hidden } = {})
  - let condition = locked ? "isKitchenSink || !unlockScreens" : hidden ? "true" : "(screen.continue || screen.start)";
  - let disabled = locked ? "!suspend.completed[sectionId]" : "audioLocked || false";
  - let vBindClass = hidden ? "['auto-alpha-0', {'auto-alpha-1':suspend.completed[sectionId]}, {'flex-col gap-2': smallDevice}]" : "[{'flex-col gap-2': smallDevice}]";

  .screen-next-button.w-full.group.flex.justify-end.items-center(
    :class=vBindClass
    v-if=condition
  )&attributes(attributes)
    template(v-if="screen.start")
      uc-button.btn.btn-lg.btn-primary.unlock.ripple.my-20.mx-auto.fade-in(
        :class="smallDevice && 'w-full'"
      )
        uc-text(
          :k="buttonText ? `${screen.id}.start` : 'Start'"
          :key="1"
          :text="buttonText || 'Start'"
          data-sfx="continue"
        )
        //- text="Start" <- for capture by translation

    template(v-if="!screen.start && !audioDoc")
      uc-text.screen-gate.px-4.text-gray-800.dark_text-gray-200.italic(
        :class="largerThanSm ? 'auto-alpha-0 auto-alpha-slow group-hover_auto-alpha-1' : 'auto-alpha-slow auto-alpha-1 fade-in'"
        :k="`${screen.id}.gate`"
        :text="screen.gate"
        v-if=`screen.gate && ${disabled}`
        uc-word-skip=""
      )
      //- KS reset button
      uc-button.btn.min-w-0.auto-alpha-0(
        :class="[smallDevice && 'w-full', suspend.completed[sectionId] && 'auto-alpha-1']"
        @click="resetScreen"
        aria-hidden="true"
        v-if="isKitchenSink"
      )
        uc-icon.text-2xl.-my-2(icon="mdi:refresh")
      uc-preload-sfx(name="continue")
      uc-button.btn.btn-primary.unlock.ripple(
        :class="[content?.course['button-color-from-closest-primary'] ? '' : content?.course?.primary && `primary-${content?.course?.primary}`, smallDevice && 'w-full', !suspend.completed[sectionId] && 'fade-in']"
        :disabled=disabled
        data-sfx="continue"
      )
        uc-text(
          :k="buttonText ? `${screen.id}.continue` : 'Next'"
          :key="1"
          :text="buttonText || 'Next'"
        )
        //- text="Next" <- for capture by translation

mixin split
  div(:class="{ 'justify-center': screen['center-y'] }")&attributes(attributes)
    block

mixin template(name)
  template(v-else-if=`screen.template === ${JSON.stringify(name)}`)
    block

mixin template-wrapper(name)
  //- if there's no name, render the default content as v-else
  template(
    v-else=!name
    v-else-if=name ? `screen.template === ${JSON.stringify(name)}` : null
  )
    +wrapper&attributes(attributes)
      +content
      block
      +next

mixin template-wrapper-dynamic-next(name)
  template(
    v-else-if=name ? `screen.template === ${JSON.stringify(name)}` : null
  )
    UseLockables(
      :condition="screen.complete"
      :id="screen.id"
      v-slot="{ locked, completables }"
    )
      +wrapper('')(:class="[{ 'items-center mx-auto': screen.center },{ 'wrapper-has-next': completables.size > 0 }]")&attributes(attributes)
        +content
        block
        //- span {{ completables }}
        //- span {{ completables.size }}
        .screen-next-button.w-full.group.flex.justify-end.items-center(
          :class="[smallDevice && 'flex-col gap-2']"
        )
          template(v-if="!audioDoc")
            template(v-if="screen.start")
              uc-button.btn.btn-lg.btn-primary.unlock.ripple.my-20.mx-auto(
                :class="smallDevice && 'w-full'"
              )
                uc-text(
                  :k="buttonText ? `${screen.id}.start` : 'Start'"
                  :key="1"
                  :text="buttonText || 'Start'"
                  data-sfx="continue"
                )
                //- text="Start" <- for capture by translation
            template(v-if="completables.size > 0 || screen.continue")
              uc-text.screen-gate.px-4.text-gray-800.dark_text-gray-200.italic(
                :class="[largerThanSm ? 'auto-alpha-0 auto-alpha-slow group-hover_auto-alpha-1' : 'auto-alpha-slow auto-alpha-1', smallDevice && 'w-full']"
                :k="`${screen.id}.gate`"
                :text="screen.gate"
                v-if="screen.gate && locked"
                uc-word-skip=""
              )
              //- KS reset button
              uc-button.btn.min-w-0.auto-alpha-0(
                :class="[smallDevice && 'w-full', !locked && 'auto-alpha-1']"
                @click="resetScreen"
                aria-hidden="true"
                v-if="isKitchenSink"
              )
                uc-icon.text-2xl.-my-2(icon="mdi:refresh")
              uc-button.btn.btn-primary.unlock.ripple(
                :class="[content?.course['button-color-from-closest-primary'] ? '' : content?.course?.primary && `primary-${content?.course?.primary}`, smallDevice && 'w-full']"
                :disabled="locked || audioLocked"
                data-sfx="continue"
              )
                uc-text(
                  :k="buttonText ? `${screen.id}.continue` : 'Next'"
                  :key="1"
                  :text="buttonText || 'Next'"
                )

mixin template-wrapper-locked(name)
  template(v-else-if=`screen.template === ${JSON.stringify(name)}`)
    +wrapper.dont-unlock&attributes(attributes)
      +content
      block
      +next({ locked: true })

mixin template-wrapper-next-hidden(name)
  template(v-else-if=`screen.template === ${JSON.stringify(name)}`)
    +wrapper.dont-unlock&attributes(attributes)
      +content
      block
      +next({ hidden: true })

div(v-if="error || invalidScreen")
  pre(class="bg-red-200 text-red-800 border p-2 block w-full" v-if="displayErrors") {{ error }}

screen-lightbox(
  :block="screen.fullscreen"
  :edit-path="editPath"
  :id="screen.id"
  :lightboxstyles="screen?.lightboxstyles"
  :screen="screen"
  v-bind="$attrs"
  v-else-if="screen.template === 'lightbox'"
)

.screen(
  :class="[screen.template && `screen--${screen.template}`, twMerge(screen.fullscreen ? 'section--fullscreen min-h-uc-screen' : 'min-h-0', screen.dark && 'dark', screen['no-fade'] && 'screen--no-fade', ...classes?.root)]"
  :data-audio="computedAudio"
  :data-queue-audio="queueAudioAttr || null"
  :data-edit-path="editPath"
  :data-show-nested-bg="showNestedBgAttr || null"
  :data-open-iframes="openIframes"
  :id="screen.id"
  :uc-dont-read="screen['dont-read'] ? '' : null"
  ref="screenEl"
  v-bind="$attrs"
  v-else=""
)
  //- tag info for word doc
  div(
    uc-dont-read=""
    uc-word-only=""
    v-if="wordDoc && !audioDoc && screen?.tag"
  )
    uc-text(
      text="[ Dynamic content ]"
      type="p"
      uc-word-italic=""
    )
    //- expose for translations
    //- text="'Any **${count}** of the following:'"
    uc-text(
      :values="{ count: screen?.tag.any }"
      :text="'Any **${count}** of the following:'"
      type="p"
      uc-word-italic=""
      v-if="screen?.tag.any"
    )
    ul
      li(v-for="tag in getTags(screen)")
        uc-text(
          :text="Boolean(tagDescription(tag)) ? `${tagDescription(tag)} (${tag})` : `${tag}`"
          uc-word-italic=""
        )

  .screen-grid
    //- screen background color and image
    //- Note that after migrating from `background-image` CSS to a `uc-asset` element, we are faking `bg-fixed`. See layout.css for more details: screen__fill--clip and screen__fill--clip_edit
    //- We only show split fill/bgs (with md_!grid) on >= medium width, otherwise they stay hidden based on layout.css display:none
    .fill.screen__fill.overflow-hidden(
      :class="['z-[-2]' ,{ 'screen__fill--clip overflow-hidden': (screen.style?.includes('bg-fixed') || screen['animate-bg']) && !isEditModeActive }, { 'screen__fill--clip_edit overflow-hidden': (screen.style?.includes('bg-fixed') || screen['animate-bg']) && isEditModeActive }, { 'md_!grid': isLeftOrRightSplit && (screen.style || computedBg) }]"
    )
      .bg-screen(
        :class="[twMerge(!isLeftOrRightSplit ? 'fill' : '', (isLeftOrRightSplit && mediumDevice) || !isLeftOrRightSplit ? classes.bg : ''), { [screen['animate-bg']]: screen['animate-bg'] && !suspend.reducedMotion && hasColorChange, 'animate-bg': screen['animate-bg'] }]"
        :style="hasColorChange ? { animationDuration: bgAnimateTime } : null"
      )
      template(v-if="typeof computedBg === 'string'")
        template(v-for="(src, index) in computedBg?.split(/ +/)")
          uc-asset.fill.w-full.h-full.object-cover.rtl_-scale-x-100(
            :class="[{ fixed: screen.style?.includes('bg-fixed'), [screen['animate-bg']]: screen['animate-bg'] && !suspend.reducedMotion, 'animate-bg': screen['animate-bg'] }]"
            :style="{ animationDuration: bgAnimateTime, animationDelay: screen.template === 'unit-title' ? '500ms' : '' }"
            :opacity="`${/ +/.test(screen['bg-opacity']) ? screen['bg-opacity']?.split(/ +/)[index] : screen['bg-opacity']}`"
            :src="src"
            :data-screen-background="screen.id"
          )
      .fg-screen.overflow-none(
        v-if="typeof screen.fg === 'string' && !suspend.reducedMotion"
        :class="twMerge('z-[20]', !isLeftOrRightSplit ? 'fill' : '', (isLeftOrRightSplit && mediumDevice) || !isLeftOrRightSplit ? classes.fg : '')"
      )
      template.overflow-none(v-if="typeof screen.fg === 'string' && !suspend.reducedMotion")
        template(v-for="src in screen.fg?.split(/ +/)")
          uc-asset.fill.w-full.h-full.object-cover.rtl_-scale-x-100(
            class="z-[20]"
            :src="src"
            fgAsset="true"
          )
      template(v-if="Array.isArray(computedBg)")
        uc-parallax.fill.overflow-hidden.rtl_-scale-x-100(
          :layers="computedBg"
          classAttr="fill w-full h-full object-cover"
        )

    template(v-if="screen.circles") 
      screen-circles(:edit-path="editPath" :screen="screen")

    //- template(v-if="screen.templates") 
    //-   .col-span-edge.templates-loop
    //-     uc-screen(:edit-path="editPath" :screen="s" v-for="(s, i) in screen.templates")

    template(v-if="false") 

    +template('split')
      screen-split(
        :edit-path="editPath"
        :screen="screen"
        :nested="nested"
      )

    +template('split-2-1')
      screen-split(
        :edit-path="editPath"
        :screen="screen"
        :nested="nested"
      )

    +template('split-1-2')
      screen-split(
        :edit-path="editPath"
        :screen="screen"
        :nested="nested"
      )

    +template('sticky-left')
      screen-sticky(:edit-path="editPath" :screen="screen")

    +template('sticky-right')
      screen-sticky(:edit-path="editPath" :screen="screen")

    +template('esg-title')
      screen-esg-title(:edit-path="editPath" :screen="screen")

    +template('course-title')
      screen-course-title(:edit-path="editPath" :screen="screen")

    +template('unit-title')
      screen-unit-title(:edit-path="editPath" :screen="screen")

    +template('subunit-title')
      screen-unit-title(:edit-path="editPath" :screen="screen" :isSubunit="true")

    +template('unit-end').items-center
      screen-unit-end(:edit-path="editPath" :nested="nested" :screen="screen")

    +template('subunit-end').items-center
      +content
      screen-unit-end(:edit-path="editPath" :nested="nested" :screen="screen" :isSubunit="true")

    +template-wrapper('dashboard').items-center.text-center
      screen-dashboard(:edit-path="editPath" :screen="screen")

    +template-wrapper-locked('subunit-dashboard').items-center.text-center
      screen-dashboard(:edit-path="editPath" :screen="screen")

    +template-wrapper('dashboard-video')
      screen-dashboard(:edit-path="editPath" :screen="screen")

    +template-wrapper('graph')
      screen-graph(:edit-path="editPath" :screen="screen")

    +template-wrapper('image')
      //- img.h-screen-full.w-auto.block.fade-in.object-contain.mx-auto(
      //-   :class="screen.styles?.img"
      //-   :src="screen.src"
      //-   :style="{ 'max-width': screen['img-size'] ? screen['img-size'] + 'rem' : '100%' }"
      //-   :uc-parallax="screen.parallax"
      //-   alt=""
      //-   v-if="screen.src"
      //- )

      uc-asset(:size="screen['img-size']" :src="screen.src" v-if="screen.src" :editPath="`${editPath}.src`")

    +template-wrapper('image-list')
      ul.flex.flex-col.gap-8.w-full.max-w-prose
        uc-animate(
          animate="slide-left"
          is="li"
          v-for="(item, i) in screen.items"
        )
          .relative.flex.gap-6
            uc-asset.object-contain.flex-none(
              :class="item.styles?.img"
              :size="item['img-size'] || screen['img-size'] || 4"
              :src="item.img"
              :editPath="`${editPath}.items.${i}.img`"
            )
            span.min-h-full.flex.items-center.flex-1
              uc-editable(
                :class="item.styles?.text"
                :edit-path="`${editPath}.items.${i}.text`"
                :k="`${item.id}.text`"
                :text="item.text"
                :values="screen['placeholder-values']"
                v-if="item.text"
              ) 

    +template('brushstroke')
      .position-edge.hidden.lg_block
        .flex.justify-end.-mr-12(:class="screen.styles?.img")
          screen-brush(v-bind="screen")

    +template-wrapper('textarea')
      screen-textarea(:edit-path="editPath" :screen="screen")

    +template-wrapper-next-hidden('question')
      screen-question(:edit-path="editPath" :screen="screen")

    +template-wrapper-next-hidden('ordering-question')
      screen-ordering-question(:edit-path="editPath" :screen="screen")

    +template-wrapper-next-hidden('grid-question')
      screen-grid-question(:edit-path="editPath" :screen="screen")

    +template-wrapper-next-hidden('likert-question')
      screen-likert-question(:edit-path="editPath" :screen="screen")

    +template-wrapper-next-hidden('confirm')
      screen-question(
        :edit-path="editPath"
        :screen="{ ...screen, 'select-count': 1, survey: 'multi' }"
      )

    +template-wrapper-next-hidden('slider')
      screen-slider(:edit-path="editPath" :screen="screen" v-bind="screen")

    +template('assessment')
      .dont-unlock.col-span-edge
        uc-assessment(:edit-path="editPath" v-bind="screen")

    +template-wrapper-locked('quiz')
      screen-quiz(:edit-path="editPath" :nested="nested" :screen="screen")

    +template('drag')
      //- TODO pasted from +template-wrapper-locked, just to get uc-content with center: true
      +wrapper.dont-unlock.items-center.text-center
        uc-content(:editPath="editPath" :screen="{ ...screen, center: true }")
        screen-drag(:edit-path="editPath" :screen="screen")
        +next({ locked: true })

    +template-wrapper('builder')
      screen-builder(:edit-path="editPath" :screen="screen")

    +template-wrapper-locked('chat')
      screen-chat(:edit-path="editPath" :screen="screen")

    +template-wrapper-locked('email')
      screen-email(:edit-path="editPath" :screen="screen")

    +template-wrapper-locked('blinds')
      screen-blinds(:edit-path="editPath" :nested="nested" :screen="screen")

    +template-wrapper-locked('voicemail')
      screen-voicemail(:edit-path="editPath" :screen="screen") 

    +template-wrapper-locked('guided-voicemail')
      screen-guided-voicemail(:edit-path="editPath" :screen="screen") 

    +template-wrapper-locked('hotspot')
      screen-hotspot(:edit-path="editPath" :screen="screen")

    +template('hotspot-fullscreen')
      screen-hotspot-fullscreen(:edit-path="editPath" :screen="{ ...screen, 'hotspot-fullscreen': true }")

    +template('hotspot-game')
      screen-hotspot-game(:edit-path="editPath" :screen="screen")

    +template-wrapper('email-plain')
      screen-email(:edit-path="editPath" :plain="true" :screen="screen")

    +template-wrapper-next-hidden('email-question')
      .flex.flex-col.lg_flex-row.gap-16.items-center
        div(class="flex-[7]")
          screen-email(:edit-path="editPath" :plain="true" :screen="screen")
        //- audio marker and queue the question audio
        audio-marker(:name="`${screen.id}-question`")
        div(:data-queue-audio="emailQuestionAudio" class="flex-[5]")
          screen-question(
            :edit-path="editPath"
            :screen="{ ...screen, 'feedback-layout': 'bottom' }"
          )

    +template-wrapper-next-hidden('voicemail-question')
      .flex.flex-col.lg_flex-row.gap-16.items-center
        .voicemail-vm(class="flex-[7]")
          screen-voicemail(
            :edit-path="editPath"
            :screen="{ ...screen, 'dont-unlock': true }"
          )

        //- audio marker for separating the question audio
        audio-marker(:name="`${screen.id}-question`")

        //- this audio is triggered after the vm audio ends, the class name is used to find it
        .voicemail-vmq(:data-audio="voicemailQuestionAudio" class="flex-[5]")
          screen-question(
            :edit-path="editPath"
            :screen="{ ...screen, 'feedback-layout': 'bottom' }"
          )

    +template-wrapper-locked('tabs')
      screen-tabs(:edit-path="editPath" :nested="nested" :screen="screen")

    +template-wrapper-dynamic-next('carousel')
      screen-carousel(:edit-path="editPath" :nested="nested" :screen="screen")

    +template('full-width-image')
      img.col-start-edge.col-end-edge.w-full(
        :src="screen.src"
        alt=""
        v-if="screen.src"
      )

    +template('video')
      .dont-unlock.col-span-edge(v-if="!audioDoc")
        .flex.flex-col.gap-6.items-center.h-full.justify-center(
          :class="!screen['no-wrap'] && 'p-6 mx-auto max-w-[80rem]'"
        )
          .text-center.flex.flex-col.gap-6
            +content

          .w-full
            uc-videojs(
              :autoScroll="screen['auto-scroll']"
              :captions="screen.captions"
              :id="'vid_' + sectionId"
              :screen="screen"
              :src="screen.src"
              controls=""
              type="application/x-mpegURL"
            )

          //- dont show the next button for wide videos with no autoscroll - they show an overlay next button instead
          .text-right.w-full.py-5(v-if="!screen['no-wrap'] && !screen['auto-scroll']")
            +next({ locked: true })

    +template('lightbox-video')
      .col-span-edge(
        :data-completed="suspend.completed['vid_' + sectionId]"
        v-if="!audioDoc"
      )
        .flex.flex-col.gap-6.items-center.justify-start.mx-auto(
          class="max-w-[60rem] min-w-[16rem] sm_min-w-[22rem] md_min-w-[30rem] lg_min-w-[40rem]"
        )
          .text-center.flex.flex-col.gap-6
            +content

          .w-full
            uc-videojs(
              :captions="screen.captions"
              :id="'vid_' + sectionId"
              :screen="screen"
              :src="screen.src"
              :lightbox="true"
              controls=""
              type="application/x-mpegURL"
            )

    +template-wrapper-dynamic-next('cards')
      screen-cards(:edit-path="editPath" :nested="nested" :screen="screen")

    +template-wrapper-dynamic-next('password-meter')
      screen-password-meter(:edit-path="editPath" :screen="screen")

    +template-wrapper-locked('flip-cards')
      screen-flip-cards(:edit-path="editPath" :nested="nested" :screen="screen")

    +template-wrapper('timeline') 
      screen-timeline(:edit-path="editPath" :nested="nested" :screen="screen")

    +template-wrapper('animation-demo') 
      screen-animation-demo(:screen="screen")

      +next

    +template('big-quote')
      +wrapper
        .big-quote.fade-in(
          :class="{ '!gap-8': !largerThanSm }"
        )
          .big-quote-img-top(v-if="screen['img-top']")
            uc-asset(
              :class="screen.styles?.img"
              :size="screen['img-size'] || 6"
              :src="screen['img-top']"
              :editPath="`${editPath}.img-top`"
            )
          .big-quote-icon(
            v-if="screen.source"
            :class="{ '!m-0': !largerThanSm }")
            uc-icon(icon="theme:quote")
          uc-editable.big-quote-text(
            :class="[{ '!text-2xl': !largerThanSm }, twMerge(screen.styles?.text)]"
            :editPath="`${editPath}.text`"
            :k="`${screen.id}.text`"
            :text="screen.text"
            :values="screen['placeholder-values']"
            v-if="screen.text"
          ) 
          .big-quote-icon.big-quote-icon--end.hidden(v-if="screen.source")
            uc-icon(icon="theme:quote-end")
          uc-editable.big-quote-source(
            :editPath="`${editPath}.source`"
            :class="{ '!text-lg': !largerThanSm }"
            :k="`${screen.id}.source`"
            :text="screen.source"
            :values="screen['placeholder-values']"
            v-if="screen.source"
          )

        uc-screen(
          :edit-path="`${editPath}.templates.${i}`"
          :screen="childScreenWithPlaceholders(s)"
          v-for="(s, i) in screen.templates"
        )

        +next.mt-32

    +template-wrapper-locked('accordion')
      screen-accordion(:edit-path="editPath" :nested="nested" :screen="screen")

    +template-wrapper-next-hidden('toggle')
      screen-toggle(:edit-path="editPath" :screen="screen")

    +template-wrapper-locked('bank')
      screen-bank(:edit-path="editPath" :nested="nested" :screen="screen")

    +template-wrapper-locked('result')
      screen-result(:edit-path="editPath" :nested="nested" :screen="screen")

    +template('slides')
      screen-slides(:edit-path="editPath" :screen="screen" nested="true")

    //- default is content
    +template-wrapper

  //-  end of tag marker
  uc-text(
    text="[ End of dynamic content ]"
    type="p"
    uc-dont-read=""
    uc-word-only=""
    uc-word-italic=""
    v-if="wordDoc && !audioDoc && screen?.tag"
  )

  .screen-grid.display-yaml-wrapper(v-if="isKitchenSink")
    uc-display-yaml.col-span-text(:object="screen")

//- Word/Audio each of the templates has a teleport target for any nested lightbox content
.word-audio-screen-lightbox-target(
  :data-teleport="s.id"
  v-if="wordDoc || audioDoc && screen?.templates"
  v-for="(s, i) in screen.templates"
)

</template>

<script setup lang="ts">
import {
  computed,
  inject,
  provide,
  ref,
  toRef,
  unref,
  watch,
  onMounted,
  watchEffect,
  onErrorCaptured,
  useAttrs,
  type Ref
} from 'vue';
import { twMerge } from '../lib/mergeStyles';
import useSuspend from '../lib/useSuspend';

import { clearQueue, play, stop, playUrlSequence } from '../lib/audio';
import ScrollTrigger from 'gsap/ScrollTrigger';
import useTheme from '../stores/useTheme';
import useAudio from '../stores/useAudio';
import bugAlert from '../lib/bugAlert';
import { nextTick } from 'vue';
import { UseLockables } from '../stores/useLockables';
import { setCompleted } from '../lib/SCORM';
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import getTags, { tagDescription } from '../lib/getTags';
import { schemaForTemplate } from '../lib/screen-schemas/index';
import useScreenAudio, {
  resolveTemplatesChainAudioUrls,
  withInheritedPlaceholderValues
} from '../lib/useScreenAudio';

const props = defineProps<{
  screen: UcScreen;
  editPath: string;
  /** True when this screen is rendered inside a compound template (e.g. split, uc-content templates[]). Suppresses the auto-play intro watcher. */
  nested?: boolean;
}>();

function childScreenWithPlaceholders(s: UcScreen): UcScreen {
  return withInheritedPlaceholderValues(
    s as unknown as Record<string, unknown>,
    props.screen as unknown as Record<string, unknown>
  ) as UcScreen;
}

const error = ref<string>();

onErrorCaptured(e => {
  bugAlert(e);
  error.value = e.message;

  return false;
});

const displayErrors = import.meta.env.DEV;

const invalidScreen = computed(() => {
  if (!props.screen) return true;
  if (typeof props.screen !== 'object') return true;

  return false;
});

const { getAudioURL } = useAudio();

const unlockScreens = inject('unlockScreens');
const audioDoc = inject('audioDoc') as boolean;
const wordDoc = unref<boolean>(inject('wordDoc'));
const isKitchenSink = inject<Ref<boolean>>('isKitchenSink');
const content = inject<Ref<{ course: object; patches: object }>>('content');
const suspend = useSuspend();
const sectionId = inject('sectionId');

// Schema-driven intro audio (Phase 0b foundation — active once schemas are registered)
const sectionActive = inject<Ref<boolean>>('sectionActive', ref(false));
const screenRef = toRef(props, 'screen');
const schema = computed(() =>
  schemaForTemplate(screenRef.value?.template as string | undefined)
);
const { resolveSlot } = useScreenAudio(screenRef, schema);

/** `uc-content` renders `screen.templates[]` with nested=true — each child skips its own watcher; we sequence their intros here after the parent intro. */
const hasTemplatesChain = computed(
  () =>
    Array.isArray(props.screen?.templates) && props.screen.templates.length > 0
);

/** Invalidate in-flight JiT resolve when the section deactivates mid-synthesis. */
let sectionIntroGeneration = 0;

/**
 * Parent intro (heading/text/instructions on the root screen object), then each
 * `templates[i]` intro in order. Split rows expand to parent + left-0 + right-0.
 */
const playSectionIntroIfActive = async () => {
  if (!sectionActive.value || props.nested) return;
  if (!schema.value || schema.value.managesOwnSectionAudio) return;
  if (!props.screen?.id) return;

  const gen = ++sectionIntroGeneration;
  const owner = props.screen.id;
  clearQueue();
  stop();

  if (hasTemplatesChain.value) {
    const urls = await resolveTemplatesChainAudioUrls(
      props.screen,
      props.screen.id,
      i => `${props.editPath}.templates.${i}`
    );
    if (gen !== sectionIntroGeneration || !sectionActive.value) return;

    playUrlSequence(urls, { owner });
    return;
  }

  const url = await resolveSlot('intro');
  if (gen !== sectionIntroGeneration || !sectionActive.value || !url) return;
  await play(url, { owner });
};

watch(sectionActive, active => {
  if (!active) {
    sectionIntroGeneration++;
    return;
  }
  void playSectionIntroIfActive();
});

// The first screen on any page never gets a false → true transition from the
// watcher above. uc-scroll-page.vue initialises currentSection to null, so
// uc-scroll-section's `sectionActive = computed(() => currentSection === $el)`
// evaluates to `null === null = true` for every section during setup. When
// uc-scroll-page mounts and sets currentSection = sections[0], the first
// section's sectionActive stays true (no change), so the watcher never fires.
//
// Awaiting nextTick lets the full synchronous mounting tree complete (including
// uc-scroll-page's mounted() that sets currentSection). After the tick, only
// the genuinely-active first section still has sectionActive = true — all
// others have transitioned to false. This mirrors the watcher logic exactly.
onMounted(async () => {
  await nextTick();
  void playSectionIntroIfActive();
});
const screenEl = ref<HTMLElement>();
const breakpoints = useBreakpoints(breakpointsTailwind);
const smallDevice = breakpoints.smallerOrEqual('sm');
const smallerThanMd = breakpoints.smaller('md');
const mediumDevice = breakpoints.greaterOrEqual('md');
const largerThanSm = breakpoints.greater('sm');
const smallerThanLg = breakpoints.smaller('lg');
const isEditModeActive = inject('isEditModeActive') as Ref<boolean>;
const showCloseButton = inject('showCloseButton') as Ref<boolean>;
// const isHidden = id => Boolean(content.value.hidden?.[id]);

// // if this screen is hidden, mark it as complete so we can progress past it
// if (isHidden(props.screen?.id)) setCompleted(props.screen?.id);

const resetScreen = (e: MouseEvent) => {
  const section = (e.target as HTMLElement).closest('.section') as HTMLElement;

  section.querySelectorAll('[id]').forEach(el => {
    delete suspend.completed[el.id];
  });

  section.querySelectorAll<HTMLElement>('[data-completables]').forEach(el => {
    el.dataset.completables?.split(',').forEach(id => {
      delete suspend.completed[id];
    });
  });

  delete suspend.completed[section.id];
};

useTheme(props.screen);

const buttonText = computed(() =>
  typeof props.screen?.continue === 'string'
    ? props.screen?.continue
    : typeof props.screen?.start === 'string'
      ? props.screen?.start
      : null
);

const classes = computed(() => {
  const fullClass = props.screen?.style || '';
  const arr = fullClass.split(' ');
  // matches bg- or md_bg- or xxl_bg- class names
  const bgPrefix = /^([a-z]{2,3}_)?bg-/;
  const bg = arr.filter((c: string) => bgPrefix.test(c));
  const root = arr.filter((c: string) => !bgPrefix.test(c));

  return { bg, root };
});

const audioAttr = computed(
  () => useAttrs()['data-audio'] as string | undefined
);
const queueAudioAttr = computed(
  () => useAttrs()['data-queue-audio'] as string | undefined
);
const showNestedBgAttr = computed(
  () => useAttrs()['show-nested-bg'] as boolean | undefined
);

const computedAudio = computed(() => {
  // set a blank data-audio attribute for certain templates
  // we check for this and don't attempt to play screen audio
  if (
    props.screen?.template === 'assessment' ||
    props.screen?.template === 'slides' ||
    props.screen?.template === 'video' ||
    props.screen?.template === 'hotspot-game'
  ) {
    return '';
  }

  // Schema-registered templates own their own audio via the sectionActive watcher.
  // Return null so uc-scroll-section doesn't also try to play the same audio.
  if (schema.value) return null;

  return (
    audioAttr.value ??
    props.screen?.audio ??
    props.screen?.speech ??
    getAudioURL(props.screen?.id)
  );
});

const emailQuestionAudio = computed(() =>
  getAudioURL(`${props.screen?.id}-question`)
);
const voicemailQuestionAudio = computed(() =>
  getAudioURL(`${props.screen?.id}-question`)
);

const isLeftOrRightSplit = computed(() => {
  const parentScreenEl = screenEl.value?.parentNode?.closest('.screen');
  const cl = parentScreenEl?.classList;
  return cl
    ? cl.contains('screen--split') ||
        cl.contains('screen--split-1-2') ||
        cl.contains('screen--split-2-1')
    : false;
});

const openIframes = computed(() =>
  typeof props.screen?.['open-iframes'] === 'boolean'
    ? props.screen?.['open-iframes']
    : unref(inject('open-iframes'))
);

provide('open-iframes', openIframes);

const bgAnimateTime = computed(() => {
  let animateTime = props.screen?.['animate-bg']?.match(/time-(\d+)/);
  animateTime = animateTime ? animateTime[1] : 5;
  return animateTime + 's';
});

const hasColorChange = computed(() => {
  return props.screen?.['animate-bg']?.match(/color-change/);
});

const audioLocked = computed(() => {
  const locked =
    content?.value.course?.audiolocked &&
    suspend.audioplaying &&
    !suspend.completed[sectionId];
  return locked;
});

const computedBg = computed(() => {
  if (props.screen?.['bg-small'] && smallerThanMd.value) {
    return props.screen?.['bg-small'];
  } else if (props.screen?.['bg-medium'] && smallerThanLg.value) {
    return props.screen?.['bg-medium'];
  } else {
    return props.screen?.bg;
  }
});
</script>

<style scoped>
/* hide left or right side of a split on small devices (use for image-only split sides) */
[class^='screen__left']:has(.screen.hide-split-on-small),
[class^='screen__right']:has(.screen.hide-split-on-small) {
  display: none;

  @media screen(md) {
    display: inherit;
  }
}
</style>
